//  ==========================================================================
//
//  Service (detail page)
//
//  ==========================================================================
import React, { PureComponent } from 'react';

import { graphql } from 'gatsby';

import striptags from 'striptags';

import {
	GridLocationDetail,
	HeroTitleOverlay,
	PortfolioBanner,
	MetaTags,
} from '../../components';

import {
	detailPageProjectTypeQuickLinks,
	normalizeServices,
	parseWhitelistedThumbnails,
} from '../../helpers';

//  ==========================================================================
//  Component
//  ==========================================================================
export default class Service extends PureComponent {
	constructor( props ) {
		super( props );

		this.serviceInfo = normalizeServices(
			this.props.data.wordsbyCollections
		);

		this.serviceInfo.hero.image = this.props.data.wordsbyCollections?.hero?.image?.childImageSharp?.heroImage;

		const encodedPostTitle = 'string' === typeof( this.serviceInfo?.slug )
			? encodeURIComponent( this.serviceInfo.slug )
			: '';

		this.ctaLinks = [
			{
				name: `Meet Our ${this.serviceInfo.post_title} Team`,
				path: `/search?contentTypes=people&services=${encodedPostTitle}`,
			},
			{
				name: `See more ${this.serviceInfo.post_title} Case Studies`,
				path: `/search?contentTypes=case-studies&services=${encodedPostTitle}`,
			},
		];

		/**
		 * If research, link to all research
		 */
		if ( 'Research' === this.serviceInfo.post_title ) {
			this.ctaLinks = [
				{
					name: `Meet Our ${this.serviceInfo.post_title} Team`,
					path: `/search?contentTypes=People&services=${encodedPostTitle}`,
				},
				{
					name: `See All ${this.serviceInfo.post_title}`,
					path: `/search?services=${encodedPostTitle}`,
				},
			];
		}
	}

	render() {
		const {
			hero,
			post_title,
			description,
			business_contact,
			short_summary,
			grid,
			grid_heading,
			type,
			yoast,
		} = this.serviceInfo;

		return (
			<main id="main">
				<MetaTags
					post_title={post_title}
					description={striptags( short_summary )}
					ogImage={hero?.imageAttachment?.file_url}
					yoast={yoast}
				/>

				<HeroTitleOverlay
					hero={hero}
					eyebrow="Services"
					post_title={post_title}
					description={description}
					link="#"
					contact={business_contact[0]}
					quickLinks={detailPageProjectTypeQuickLinks}
					ctaLinks={this.ctaLinks}
				/>

				<section className="content-contain overflow-hidden">
					<GridLocationDetail
						curatedContentTitle={grid_heading}
						curatedContent={( grid || [] ).map( parseWhitelistedThumbnails )}
					/>
				</section>
				<PortfolioBanner
					projectType={post_title}
					contact={business_contact[0]}
					link={
						'Research' !== this.serviceInfo.post_title
							? this.ctaLinks[0].path
							: this.ctaLinks[1].path
					}
					type={type}
				/>
			</main>
		);
	}
}

export const serviceQuery = graphql`
	query ServiceByID($id: Int!) {
		wordsbyCollections(ID: { eq: $id }) {
			...PostFields
			...HeroComponent

			...ThumbnailFields

			business_contact {
				relationshipByID {
					...PersonFragment
				}
			}
			short_summary
			description
			grid_heading
			grid {
				relationshipByID {
					...CardComponent
					...QuoteComponent
				}
				post_type
				post_status
			}
		}
	}
`;
